import React from 'react';
import { Grid } from '@mui/material'
import FeaturedProjects from './FeaturedProjects';
import GoogleAnalytics from './GoogleAnalytics';

const Dashboard = () => {
  return (
    <>
      <Grid item xs={12} sx={{ marginBottom: '4rem' }}>
        <GoogleAnalytics />
      </Grid>
      <Grid item xs={12} sx={{ paddingBottom: '2rem' }}>
        <FeaturedProjects />
      </Grid>
    </>
  );
};

export default Dashboard;
